import { CircularProgress, Stack } from '@mui/material';

export interface ScreenLoadingProps {
  height?: string;
}

const ScreenLoading = ({ height = '100vh' }: ScreenLoadingProps) => {
  return (
    <Stack width={'100%'} height={height} alignItems={'center'} justifyContent={'center'}>
      <CircularProgress />
    </Stack>
  );
};

export default ScreenLoading;
